import Vue from 'vue'
import VueRouter from 'vue-router'
import VueMeta from 'vue-meta'
import Home from '../views/Home.vue'
import Carbon from '../views/Carboon.vue'
import CarbonNeutral from '../views/CarbonoNeutral.vue'
import Water from '../views/Water.vue'
import Huella from '../views/Huella.vue'
import Enel from '../views/Enel.vue'
import politicas from '../components/Politica.vue'
import NotFound from '../components/Notfound.vue'

Vue.use(VueRouter)
Vue.use(VueMeta)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    component: () => import( '../views/About.vue')
  },
  {
    path: '/huelladecarbono',
    name: 'huelladecarbono',
    component: Carbon
  },
  {
    path: '/carbonoNeutral',
    name: 'carbonNeutral',
    component: CarbonNeutral
  },
  {
    path: '/huelladeagua',
    name: 'huelladeagua',
    component: Water
  },
  {
    path: '/huellaChile',
    name: 'huellachile',
    component: Huella
  },
  {
    path: '/energiarenovable',
    name: 'enel',
    component: Enel
  },
  {
    path: '/politicas-de-privacidad',
    name: 'politicas',
    component: politicas
  },
  { 
    path: '*',
    component: NotFound 
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
